<template>
  <li class="has-submenu action">
    <a href="javascript:void(0)" @click="onMenuClick">
      <img
        :src="getIconLocale(selectedOptionLanguage.iso)"
        :alt="selectedOptionLanguage.value"
        class="img-locale"
      />
      {{ language992To1200 ? '' : selectedOptionLanguage.label }}
    </a>
    <span class="menu-arrow"></span>
    <ul class="submenu">
      <li v-for="(option, index) in filterOptionsLanguage" :key="index">
        <a
          href="javascript:void(0)"
          class="side-nav-link-ref"
          @click="onChangeLanguage(option.value)"
        >
          <img :src="getIconLocale(option.iso)" :alt="option.value" class="img-locale" />
          {{ option.label }}
        </a>
      </li>
    </ul>
  </li>
</template>

<script>
import { loadLanguageAsync } from '@/setup/i18n';
import { lsGetSettingByName } from 'helpers/local-storage';
import MediaQueriesMixin from 'mixins/MediaQueriesMixin';

export default {
  name: 'Language',

  mixins: [MediaQueriesMixin],

  data() {
    return {
      selectedLanguage: lsGetSettingByName('locale') || this.$i18n.locale
    };
  },

  computed: {
    optionsLanguage() {
      return [
        { label: this.$t('language.es'), iso: 'es', value: 'es' },
        { label: this.$t('language.en'), iso: 'us', value: 'en' }
      ];
    },

    selectedOptionLanguage() {
      return this.optionsLanguage.filter(item => item.value === this.selectedLanguage)[0];
    },

    filterOptionsLanguage() {
      return this.optionsLanguage.filter(item => item.value !== this.selectedLanguage);
    }
  },

  methods: {
    onChangeLanguage(value) {
      loadLanguageAsync(value).then(() => {
        window.location.href = ''; // Reload page
      });
    },

    onMenuClick(event) {
      this.$parent.onMenuClick(event);
    },

    getIconLocale(iso) {
      return `https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.1.0/flags/4x3/${iso}.svg`;
    }
  }
};
</script>

<style lang="scss" scoped>
.img-locale {
  max-height: 13px;
  margin-right: 5px;
  border-radius: 1px;
  vertical-align: middle;
  margin-top: -3px;
}
</style>
